import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  deleteMedia(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.environment.endPoint}media/${id}`);
  }

  getMediaUrl(mediaId: String): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${this.environment.endPoint}media/${mediaId}`);
  }

  uploadImage(media: FormData): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(`${this.environment.endPoint}media`, media);
  }
}
